<script setup lang="ts">
import UserEntityItemThumbnailComponent from '../../user/UserEntityItemThumbnailComponent.vue'
import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'

interface Props {
  payload: {
    entity: IResponseEntity
  }
}
const props = defineProps<Props>()
</script>

<template>
  <UserEntityItemThumbnailComponent :entity="payload.entity"/>
</template>
